export const BTN = {
    searchData: "ค้นหาข้อมูล",
    back: "ย้อนกลับ",
    refresh: "ล้างข้อมูล",
    save: "บันทึกข้อมูล",
    connext: "ดำเนินการต่อ",
    edit:"แก้ไขข้อมูล",
    next: "ถัดไป",
    cancel: "ยกเลิก",
    ok: "OK",
    confirm:"ยืนยัน",
    back_search: "กลับค้นหา",
    add_data:"เพิ่มข้อมูล",
    search_abb: "ค้นหาใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ",
    download:"download",
    confirmTexinvoice:"ยืนยันการออกใบกำกับภาษี",
    confirmReplace:"ยืนยันการออกเอกสารทดแทน",
};